import { Button } from "react-bootstrap";
import CommonModal from "../../../../../../core/common/commonModal";

interface DeleteLeaveModalProps {
    visible: boolean;
    leaveToDelete: any;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

const DeleteLeaveModal: React.FC<DeleteLeaveModalProps> = ({
    visible,
    leaveToDelete,
    onClose,
    onConfirm,
}) => {
    return (
        <CommonModal
            id="delete_leave_modal"
            title="Confirm Cancellation"
            visible={visible}
            onClose={onClose}
            footer={
                <>
                    <Button variant="secondary" onClick={onClose} className="m-2">
                        Close
                    </Button>
                    <Button variant="danger" onClick={onConfirm}>
                        Confirm Cancellation
                    </Button>
                </>
            }
        >
            <div className="delete-modal-content">
                <p>Are you sure you want to cancel this leave request?</p>
                {leaveToDelete && (
                    <div className="mt-3">
                        <p>
                            <strong>Leave Type:</strong> {leaveToDelete.LeaveType}
                        </p>
                        <p>
                            <strong>From:</strong> {leaveToDelete.From} <strong>To:</strong>{" "}
                            {leaveToDelete.To}
                        </p>
                        <p>
                            <strong>Days:</strong> {leaveToDelete.NoOfDays}
                        </p>
                    </div>
                )}
            </div>
        </CommonModal>
    );
};

export default DeleteLeaveModal;
